<template>
  <div class="row">
    <div class="col-md-12">
      <modal :show.sync="ModalProduct">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Editar Producto</h5>
        </template>
        <div>
          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="onSubmit">
              <div class="text-left col-12">
                <H3 v-if="SelectProductType">Edición de producto variable</H3>
                <H3 v-else>Edición de producto simple</H3>
                <base-alert v-if="msscategory" :type="alertmss" dismissible>
                  <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                  <span class="alert-inner--text">{{ msscategory }}</span>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </base-alert>
              </div>

              <div class="row">
                <span class="text-info-product">Encabezado del producto</span>

                <div class="col-12 row field-content-mobile">
                  <div class="col-3 field-mobile">
                    <label for="name">Nombre producto</label>
                    <ValidationProvider name="product.name" rules="required"
                                        v-slot="{ errors }">
                      <input
                          id="name"
                          v-model="product.name"
                          type="text"
                          class="form-control"
                          placeholder="Nombre"
                      >
                      <p class="error-acre">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-3 field-mobile">

                    <label class="typo__label">Categoria</label>
                    <multiselect
                        placeholder="Busque o agregue categoria"
                        tag-placeholder="Agregar categoria"
                        v-model="product.Category"
                        :options="Category"
                        :searchable="true"
                        track-by="category_id"
                        label="category"
                        :multiple="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :taggable="true" @tag="addTag">
                    </multiselect>

                  </div>
                  <!--  <div class="col-2">
                        <label class="typo__label">Tipo de producto</label>
                        <multiselect
                                v-model="product.ProductType"
                                :options="ProductType"
                                :searchable="false"
                                track-by="product_type_id"
                                label="type_name"
                                :close-on-select="false"
                                :show-labels="false"
                                placeholder="Seleccione una opción"></multiselect>
                    </div>-->
                  <div class="col-3 field-mobile">
                    <label class="typo__label">Unidad de medida</label>
                    <multiselect v-model="product.unit" tag-placeholder="Agregar una nueva"
                                 placeholder="Seleccionar Unidad" label="unit_name"
                                 track-by="unit_type_id" :options="UnitType"
                                 :multiple="true"></multiselect>
                  </div>
                  <div class="col-3 field-mobile">
                    <label for="name">Iva</label>
                    <ValidationProvider name="product.tax" rules="required"
                                        v-slot="{ errors }">
                      <input
                          id="tax"
                          v-model="product.tax"
                          type="number"
                          class="form-control"
                      >
                      <p class="error-acre">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>

                </div>
                <span class="text-info-product">Crear SKU del producto</span>
                <div class="col-12 text-left field-content-mobile">
                  <base-alert v-show="position_edit === true" type="warning">
                    <span class="alert-inner--icon"><i class="ni ni-ruler-pencil"></i></span>
                    <span class="alert-inner--text"><strong> Modo edición de variante SKU</strong></span>
                  </base-alert>
                </div>
                <div class=" col-12 row field-content-mobile">
                  <div class="col-4 field-mobile">
                    <label for="sku">Codigo SKU</label>
                    <input
                        id="sku"
                        v-model="product_sku.sku"
                        type="text"
                        class="form-control"
                        placeholder="Codigo SKU"
                    >
                    <p class="error-acre">{{ valsku }}</p>
                  </div>

                  <div v-show="SelectProductType" class="col-4 field-mobile">
                    <label for="namesku">Nombre</label>
                    <input
                        id="namesku"
                        v-model="product_sku.name"
                        type="text"
                        class="form-control"
                        placeholder="Nombre"
                    >
                  </div>
                  <div class="col-4 field-mobile">
                    <label for="descryption">Descripción</label>
                    <input
                        id="descryption"
                        v-model="product_sku.description"
                        type="text"
                        class="form-control"
                        placeholder="Descripción"
                    >
                  </div>
                  <div class="col-4 field-mobile">
                    <label for="stock">Stock</label>
                    <input
                        id="stock"
                        v-model="product_sku.Inventory.stock_quantity"
                        type="number"
                        class="form-control"
                        placeholder="Stock"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_uni">
                    <label for="stockcreUni">Equivalencia de Unidad a Kilo</label>
                    <input
                        id="stockcreUni"
                        v-model="product_sku.Inventory.unit_stock_quantity"
                        type="number"
                        class="form-control"
                        placeholder="Peso"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_price">
                    <label for="price">Precio Kilo</label>
                    <input
                        id="price"
                        v-model="product_sku.price"
                        type="number"
                        class="form-control"
                        placeholder="Precio"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_uni">
                    <label for="pricegr">Precio Unidad</label>
                    <input
                        id="pricegr"
                        v-model="product_sku.unit_price"
                        type="number"
                        class="form-control"
                        placeholder="Precio"
                    >
                  </div>
                  <!-- <div class="col-4">
                       <label for="onsale"> Onsale</label>
                       <br>
                       <span>Sin Descuento</span>
                       <label class="custom-toggle">
                           <input type="checkbox"
                                  id="onsale"
                                  v-model="product_sku.onsale">
                           <span class="custom-toggle-slider rounded-circle"></span>
                       </label> <span>Descuento</span>

                   </div>-->
                  <div class="col-4 field-mobile radio-default-acre">
                    <label class="text-info-product"> Estado SKU: </label>
                    <PrettyRadio v-model="product_sku.state_id.state_id" class="p-default p-round" :value="true"
                                 name="radio2">Activo
                    </PrettyRadio>
                    <PrettyRadio v-model="product_sku.state_id.state_id" class="p-default p-round" :value="false"
                                 name="radio2">Inactivo
                    </PrettyRadio>
                  </div>

                  <div class="col-12 text-left field-mobile">
                    <label for="file">Imagen de producto</label>
                    <br>
                    <input type="file" id="file" ref="file"
                           v-on:change="onChangeFileUpload()"/>
                    <img v-if="img_preview" style="width: 33px" :src="img_preview"/>
                    <img v-if="product_sku.Skuid && img_preview === null" :src="full_url_img+getimg(product_sku.Skuid)"
                         alt=""
                         style="width: 33px">

                  </div>

                  <div v-show="SelectProductType" class="col-12 btn-add-sku">
                    <base-button :disabled="btn_addsku" size="sm" outline type="default"
                                 @click="addsku"
                    >{{ btneditsku }}
                    </base-button>
                  </div>
                </div>
              </div>
              <div v-show="SelectProductType" class="row">
                <span>Detalle SKU</span>
                <div class="table-responsive table-flush">

                  <table class="table  table-striped align-items-center">
                    <thead>
                    <th></th>
                    <th>Nombre</th>
                    <th>Codigo SKU</th>
                    <th>Descripcion</th>
                    <th>Precio KL</th>
                    <th>Precio Unidad</th>
                    <th>Stock</th>
                    <th></th>
                    </thead>
                    <tbody v-if="data_product_sku.length > 0 ">
                    <tr v-for="(row, index) in data_product_sku" :key="index" v-show="row.deletedAt===null">
                      <td>
                        <img v-if="row.img" :src="row.img"
                             alt=""
                             style="width: 33px">
                        <img v-else :src="full_url_img+getimg(row.Skuid)" alt=""
                             style="width: 33px">

                      </td>
                      <th scope="row">
                        <div class="media align-items-center">
                          <div class="media-body">
                            <span class="name mb-0 text-sm">{{ row.name }}</span>
                          </div>
                        </div>
                      </th>
                      <td>
                        {{ row.sku }}
                      </td>
                      <td>
                        {{ row.description }}
                      </td>
                      <td class="budget">
                        {{ row.price }}
                      </td>
                      <td class="budget">
                        {{ row.unit_price }}
                      </td>
                      <td class="budget">
                        <span v-if="row.Inventory != null">{{ row.Inventory.stock_quantity }}</span>
                      </td>

                      <td>
                        <base-button size="sm" type="info" icon="ni ni-ruler-pencil"
                                     @click="editsku(index,row.sku_product_id)"></base-button>
                        <base-button size="sm" type="danger"
                                     @click="deletesku(index,row.sku_product_id)"
                                     icon="ni ni-fat-remove"></base-button>
                      </td>

                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <base-alert v-show="error" type="warning">
                <strong>{{ error }}</strong>
              </base-alert>
              <base-button @click="update" v-show="btn_update === true" :disabled="invalid" class="btn-save btn_submit">
                Guardar
              </base-button>
            </form>
          </ValidationObserver>
        </div>
        <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                       label="Guardando"></base-progress>
        <template slot="footer">

        </template>

      </modal>
    </div>
  </div>
</template>

<script>
import {bus} from "./bus-product"
import _ from "lodash"
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {product_service} from "../../services/product/ProductService"
import swal from "sweetalert"
import PrettyRadio from 'pretty-checkbox-vue/radio'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'


extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "EditProduct",
  components: {ValidationProvider, ValidationObserver, PrettyRadio},
  data() {
    return {
      alertmss: 'success',
      msscategory: '',
      progress: 0,
      img_preview: null,
      constants: {},
      full_url_img: '',
      btneditsku: 'Agregar SKU',
      error: '',
      position_edit: false,
      valsku: '',
      products: [],
      productssku: {},
      btn_addsku: true,
      btn_update: true,
      file: '',
      input_uni: false,
      input_price: true,
      ModalProduct: false,
      SelectProductType: false,
      data_product_sku: [],
      file_sku: [],
      data_product_inventory: [],
      Category: [],
      ProductType: [],
      UnitType: [],
      position_edit_product: -1,
      product: {
        product_id: 0,
        name: '',
        tax: 0,
        Category: {},
        ProductType: {},
        UnitType: {
          "unit_type_id": 1,
          "unit_name": "Kilo",
          "shotname": "KL"
        },
        unit: {}
      },
      product_sku: {
        sku_product_id: 0,
        sku: '',
        price: 0,
        unit_price: 0,
        description: '',
        onsale: 0,
        deletedAt: null,
        name: '',
        img: null,
        product_id: {
          product_id: 0
        },
        state_id: {
          state_id: 1
        },
        Inventory: {
          inventory_id: 0,
          stock_quantity: 0,
          unit_stock_quantity: 0
        },
        Skuid: []
      },
      product_inventory: {
        stock_quantity: '',
        unit_stock_quantity: '',
        productskuSkuProductId: ''
      }

    }
  },
  watch: {
    'product.unit': function () {

      const w = _.find(this.product.unit, function (item) {
        if (item.shotname === 'Uni') {
          return true
        } else {
          return false
        }
      })
      const k = _.find(this.product.unit, function (item) {
        if (item.shotname === 'KL' || item.shotname === 'GR') {
          return true
        } else {
          return false
        }
      })
      if (w === false) {
        this.input_uni = false
        this.product_sku.unit_price = 0
      } else {
        this.input_uni = w
      }
      if (k === false) {
        this.input_price = false
        this.product_sku.price = 0
      } else {
        this.input_price = k
      }
    },
    'product_sku.sku': function () {
      const p = _.filter(this.productssku, (c) => {
        if (c.sku === this.product_sku.sku) {
          return c
        }
      })
      let sku
      let sku_product_id
      for (const prop in p) {
        sku = p[prop].sku
        sku_product_id = p[prop].sku_product_id
      }
      //console.log(this.product_sku.sku_product_id +'-'+p[0].sku_product_id+'-'+this.product_sku.sku+'-'+p[0].sku)
      console.log(p.length)
      if (p.length >= 1) {
        //console.log(this.product_sku.sku + ' - ' + sku)
        //console.log(this.product_sku.sku_product_id + ' - ' + sku_product_id)
        //console.log(this.position_edit_product)
        if (this.position_edit_product >= 0) {

          if (this.product_sku.sku_product_id === sku_product_id && this.product_sku.sku === sku) {
            this.btn_addsku = false
            this.valsku = ''
          } else {
            this.btn_addsku = true
            this.valsku = 'El SKU ya existe'
          }
        } else {
          this.btn_addsku = true
          this.valsku = 'El SKU ya existe'
        }

      } else if (this.product_sku.sku === '') {
        this.btn_addsku = true
        this.valsku = 'El SKU no puede estar vacio'
      } else {
        this.btn_addsku = false
        this.valsku = ''
      }

    }
  },
  methods: {
    addTag(newTag) {
      let data = {
        category: newTag
      }
      product_service.CreateCategory(data)

    },
    getimg(arr) {
      if (arr.length > 0) {
        const arr_img = arr
        for (const img in arr_img) {
          return arr_img[img].img_url
        }
      }

    },
    ShowProduct() {
      this.ModalProduct = !this.ModalProduct
    }
    ,
    update() {
      if (this.SelectProductType === false) {
        //console.log(this.product_sku.sku.length)
        if (this.product_sku.sku != '') {
          this.createsimple()
          this.progress = 20
        } else {
          this.error = 'Debe Ingresar un SKU'
        }


      }
      if (this.SelectProductType === true) {
        if (this.data_product_sku.length > 0) {
          this.createvariable()
          this.progress = 20
        } else {
          this.error = 'Debe Ingresar una variable'
        }

      }
    }
    ,
    createvariable() {
      this.btn_update = false
      this.product.ProductType = {
        product_type_id: 2
      }
      this.product.unit = JSON.stringify(this.product.unit)
      //console.log(this.data_product_sku)
      product_service.UpdateProduct(this.product)

    }
    ,
    createsimple() {
      this.btn_update = false
      /*   if (this.product_sku.onsale === true) {
             this.product_sku.onsale = 1
         } else {
             this.product_sku.onsale = 0
         }*/
      this.product_sku.onsale = 0
      if (this.product_sku.state_id.state_id === true || this.product_sku.state_id.state_id === 1) {
        this.product_sku.state_id.state_id = 1
      } else {
        this.product_sku.state_id.state_id = 2
      }
      this.product.ProductType = {
        product_type_id: 1
      },
          this.data_product_sku.push(this.product_sku)
      this.file_sku.push({'sku': this.product_sku.sku, 'image': this.file})
      this.product.unit = JSON.stringify(this.product.unit)
      product_service.UpdateProduct(this.product)
    }
    ,
    addsku() {
      let img = null
      if (this.file[0]) {
        img = URL.createObjectURL(this.file[0])
      }
      //console.log(this.position_edit_product)
      if (this.position_edit_product >= 0) {
        if (this.product_sku.state_id.state_id === true || this.product_sku.state_id.state_id === 1) {
          this.product_sku.state_id.state_id = 1
        } else {
          this.product_sku.state_id.state_id = 2
        }
        let items = {
          sku_product_id: this.product_sku.sku_product_id,
          sku: this.product_sku.sku,
          price: this.product_sku.price,
          unit_price: this.product_sku.unit_price,
          description: this.product_sku.description,
          onsale: this.product_sku.onsale,
          name: this.product_sku.name,
          deletedAt: null,
          img: img,
          product_id: {
            product_id: this.product.product_id
          },
          state_id: {
            state_id: this.product_sku.state_id.state_id
          },
          Inventory: {
            inventory_id: this.product_sku.Inventory.inventory_id,
            stock_quantity: Number(this.product_sku.Inventory.stock_quantity),
            unit_stock_quantity: Number(this.product_sku.Inventory.unit_stock_quantity)
          },
          Skuid: this.product_sku.Skuid
        }
        this.data_product_sku.splice(this.position_edit_product, 1, items)
        this.file_sku.push({'sku': this.product_sku.sku, 'image': this.file})
        //console.log(this.data_product_sku)
        this.cleandata()
        this.btn_update = true


      } else {
        if (this.product_sku.state_id.state_id === true) {
          this.product_sku.state_id.state_id = 1
        } else {
          this.product_sku.state_id.state_id = 2
        }
        this.product_sku.deletedAt=null
        this.product_sku.img = img
        this.data_product_sku.push(this.product_sku)
        this.file_sku.push({'sku': this.product_sku.sku, 'image': this.file})
        this.cleandata()
        this.btn_update = true
      }

    }
    ,
    deletesku(x, id) {
      this.data_product_sku.splice(x, 1)
      if (id != undefined) {
        product_service.DeleteSKU(id)
        product_service.GetAllProductSku()
      }

    }
    ,
    editsku(x, id) {
      const p = _.find(this.data_product_sku, function (item) {
        return item.sku_product_id === id
      })

      this.btneditsku = 'Editar SKU'
      this.btn_update = false
      this.position_edit_product = x
      this.position_edit = true
      this.product_sku.name = p.name
      this.product_sku.deletedAt = p.deletedAt
      this.product_sku.sku_product_id = p.sku_product_id
      this.product_sku.product_id.product_id = p.product_id.product_id
      this.product_sku.sku = p.sku
      this.product_sku.description = p.description
      this.product_sku.unit_price = p.unit_price
      this.product_sku.price = p.price

      if (p.Inventory != null) {
        this.product_sku.Inventory.inventory_id = p.Inventory.inventory_id
        this.product_sku.Inventory.stock_quantity = p.Inventory.stock_quantity
        this.product_sku.Inventory.unit_stock_quantity=p.Inventory.unit_stock_quantity
        this.product_sku.Inventory.productskuSkuProductId = p.Inventory.productskuSkuProductId
      }
      if (p.Skuid != null) {
        this.product_sku.Skuid = p.Skuid
      }
      /* if (p.onsale === 1) {
           this.product_sku.onsale = true
       } else {
           this.product_sku.onsale = false
       }*/
      if (p.state_id.state_id === 1) {
        this.product_sku.state_id.state_id = true
      } else {
        this.product_sku.state_id.state_id = false
      }
    }
    ,
    cleandata() {
      this.img_preview = null
      this.product_sku = {
        sku: '',
        price: 0,
        unit_price: 0,
        description: '',
        img: null,
        onsale: 0,
        name: '',
        product_id: {
          product_id: 0
        },
        state_id: {
          state_id: 1
        },
        Inventory: {
          stock_quantity: '',
          unit_stock_quantity: '',
          productskuSkuProductId: ''
        },
        Skuid: []
      }
      this.product_inventory = {
        "stock_quantity": 0,
        "unit_stock_quantity": 0,
        "Productsku": {
          "sku_product_id": 0
        }
      }
      this.position_edit_product = -1
      this.position_edit = false
      this.file = ''
      const input = this.$refs.file;
      input.type = 'text';
      input.type = 'file';
      this.msscategory = '';
    }
    ,
    cleandatafull() {
      this.product = {
        product_id: 0,
        name: '',
        tax: 0,
        Category: {},
        ProductType: {},
        UnitType: {
          "unit_type_id": 1,
          "unit_name": "Kilo",
          "shotname": "KL"
        },
        unit: {}
      }
      this.progress = 0
      this.file_sku = []
      this.data_product_sku = []
      this.data_product_inventory = []
      this.cleandata()
      this.ShowProduct()
      this.btn_update = true
      this.error = ''
      product_service.GetAllProduct()
      product_service.GetAllProductSku()
      product_service.GetAllCategory()
      product_service.GetAllProductType()
      product_service.GetAllUnitType()
    }
    ,
    onChangeFileUpload() {
      this.file = this.$refs.file.files;
      this.img_preview = URL.createObjectURL(this.file[0]);
    }
  },
  created() {
    (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
    this.full_url_img = this.constans.IMG_PATH;
    product_service.GetAllProductAll()
    bus.$on('GetAllCategory', (response) => {
      this.Category = response
    })
    bus.$on('GetAllProductType', (response) => {
      this.ProductType = response
    })
    bus.$on('GetAllUnitType', (response) => {
      this.UnitType = response
    })
    bus.$on('GetAllProductAll', (response) => {
      this.products = response
    })
    bus.$on('ShowProductEdit', (id) => {
      this.ShowProduct()
      this.cleandata()
      const p = _.find(this.products, function (item) {
        return item.product_id === id
      })
      console.log(p)
      //producto simple
      if (p.Sku.length > 0 && p.ProductType.product_type_id === 1) {
        this.position_edit_product = 0
        this.SelectProductType = false
        this.product_sku.sku_product_id = p.Sku[0].sku_product_id
        this.product_sku.name = p.Sku[0].name
        this.product_sku.description = p.Sku[0].description
        this.product_sku.sku = p.Sku[0].sku
        this.product_sku.deletedAt = p.Sku[0].deletedAt
        this.product_sku.price = p.Sku[0].price
        this.product_sku.unit_price = p.Sku[0].unit_price
        if (p.Sku[0].Inventory) {
          this.product_sku.Inventory = p.Sku[0].Inventory
        }
        if (p.Sku[0].Skuid) {
          this.product_sku.Skuid = p.Sku[0].Skuid
        }
        this.product_sku.state_id = p.Sku[0].state_id
        if (this.product_sku.state_id.state_id === 1) {
          this.product_sku.state_id.state_id = true
        }
        if (this.product_sku.state_id.state_id === 2) {
          this.product_sku.state_id.state_id = false
        }
      }
      if (p.ProductType.product_type_id === 2) {
        this.SelectProductType = true
        this.data_product_sku = p.Sku
      }
      //encabezado producto
      this.product.product_id = p.product_id
      this.product_sku.product_id.product_id = p.product_id
      this.product.name = p.name
      this.product.tax = p.tax
      this.product.Category = p.Category
      this.product.ProductType = p.ProductType
      if (p.unit != "" || p.unit != null) {
        this.product.unit = JSON.parse(p.unit)
      } else {
        this.product.unit = [{
          "unit_type_id": 1,
          "unit_name": "Kilo",
          "shotname": "KL"
        }]
      }

      // this.data_product_inventory =
      // console.log(p.Sku)

    })

    bus.$on('ResponseUpdateProduct', (response) => {
      if (response.status === 200) {
        if (this.data_product_sku && this.data_product_sku.length > 0) {
          product_service.UpdateProductSku(this.data_product_sku)
          this.progress = 40
        } else {
          this.cleandatafull()
          swal({
            icon: "success",
            text: "Se Ha creado Un Producto Con Exito",
            button: "Aceptar"
          })
        }
      } else {
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Registro El SKU Del Producto Correctamente, !Edita el producto¡",
          button: "Aceptar"
        })
      }

    })
    bus.$on('ResponseUpdateProductSku', (response) => {
          if (response.data.length > 0) {
            this.progress = 60
            const arr = response.data
            //crea inventario por SKU variante
            for (const prop in arr) {
              if (arr[prop].Inventory != null) {
                if (arr[prop].Inventory.inventory_id > 0) {
                  this.data_product_inventory.push({
                    "inventory_id": arr[prop].Inventory.inventory_id,
                    "stock_quantity": arr[prop].Inventory.stock_quantity,
                    "unit_stock_quantity":arr[prop].Inventory.unit_stock_quantity,
                    "Productsku": {"sku_product_id": arr[prop].sku_product_id}
                  })
                } else {
                  this.data_product_inventory.push({
                    "stock_quantity": arr[prop].Inventory.stock_quantity,
                    "unit_stock_quantity":arr[prop].Inventory.unit_stock_quantity,
                    "Productsku": {"sku_product_id": arr[prop].sku_product_id}
                  })
                }

              }
            }
            if (this.SelectProductType === false) {
              //simple
              if (this.product_sku.Inventory.productskuSkuProductId === "") {

                let arr = response.data
                this.product_sku.Inventory = {
                  "stock_quantity": this.product_sku.Inventory.stock_quantity,
                  "unit_stock_quantity":this.product_sku.Inventory.unit_stock_quantity,
                  "Productsku": {"sku_product_id": arr[0].sku_product_id}
                }
                product_service.CreateProductInventory(this.product_sku.Inventory)
              } else {
                product_service.EditProductInventory(this.product_sku.Inventory)
              }

            }
            if (this.SelectProductType === true) {
              //variante
              product_service.EditProductInventory(this.data_product_inventory)
            }
            this.progress = 80
            const arr_img = this.file_sku
            if (arr_img.length > 0) {
              for (const arrimg in arr_img) {
                product_service.CreateProductSkuGalery(arr_img[arrimg].sku, arr_img[arrimg].image)

              }
            }
            this.progress = 100
          } else {
            this.cleandatafull()
            swal({
              dangerMode: true,
              icon: "error",
              text: "No Se Actualizo El SKU Del Producto Correctamente, !Edita el producto¡",
              button: "Aceptar"
            })
          }
        }
    )
    bus.$on('ResponseUpdateProductInventory', (response) => {
      console.log(response)
      if (response.statusText === 'Created' || response.statusText === 'OK') {
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Actualizado El Producto Con Exito",
          button: "Aceptar"
        })
      } else {
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Asignar Stock Al Producto, !Edita el producto¡",
          button: "Aceptar"
        })
      }
    })
    bus.$on('GetAllProductSku', (response) => {
      this.productssku = _.filter(response, (c) => {
        if (c.deletedAt === null) {
          return c
        }
      })

    })
    bus.$on('ResponseCreateCategory', (response) => {
      product_service.GetAllCategory()
      if (response.statusText === 'Created') {
        this.product.Category = response.data
        this.msscategory = 'La categoria ' + response.data.category + ' se creo correctamenta'
      } else {
        this.alertmss = 'danger'
        this.msscategory = 'La categoria ' + response.data.category + ' no fue posible crearla. !Intenta nuevamente¡'
      }
      setTimeout(() => this.msscategory = '', 4000);
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .radio-default-acre {
    margin-bottom: 2em !important;;
  }
}
</style>